import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { Link } from 'gatsby';

import Seo from '../components/common/seo';
import AboutHeader from '../components/common/AboutHeader';

const About = () => (
  <>
    <Seo title='About' />
    <AboutHeader />
    <Col
      className='d-flex flex-column justify-content-between'
      style={{ minHeight: '100vh' }}>
      <Col>
        <h2 className='px-4 header-title text-center'>
          struggling to find your niche?
        </h2>
      </Col>

      <Col className='mx-auto w-75'>
        <p className='quiz-paragraph subhead-grey'>
          With our service, finding your major has never been easier. Just spare
          a few minutes of your time and your matching algorithm will do all the
          hard work for you.
        </p>
      </Col>
      <Col className='d-flex justify-content-end'>
        <Row className='mx-auto'>
          <Button
            tag={Link}
            to='/app'
            className='bg-primary text-white'
            style={{ maxHeight: '50px' }}>
            take the quiz
          </Button>
        </Row>
      </Col>
    </Col>
    <div className='d-flex flex-row justify-content-between align-items-center overflow-hidden'></div>
  </>
);

export default About;
